import React, { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import { getErrorReporter } from 'shared/services/error-tracking';

import { version } from '../../../package.json';
import { GenericError } from './generic-error';
import { NotFound } from './not-found';

const notFoundCodes = ['permission-denied'];

export const ErrorPage: React.FC = () => {
  const error = useRouteError() as any;
  const [errors, setErrors] = useState<string[]>([]);

  useEffect(() => {
    const eventId = getErrorReporter().captureException(error, {
      tags: { source: 'route-error-boundary' },
    });
    if (!eventId) {
      return;
    }
    setErrors((oldIds) => [...oldIds, [version, eventId].join('-')]);
  }, [error]);

  if (!error || notFoundCodes.includes(error.code)) {
    return <NotFound errors={errors} />;
  }

  return <GenericError errors={errors} />;
};
